/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OtherPaymentMethod
 */
export interface OtherPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof OtherPaymentMethod
     */
    type: OtherPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OtherPaymentMethod
     */
    name: string;
}


/**
 * @export
 */
export const OtherPaymentMethodTypeEnum = {
    Other: 'other'
} as const;
export type OtherPaymentMethodTypeEnum = typeof OtherPaymentMethodTypeEnum[keyof typeof OtherPaymentMethodTypeEnum];


/**
 * Check if a given object implements the OtherPaymentMethod interface.
 */
export function instanceOfOtherPaymentMethod(value: object): value is OtherPaymentMethod {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OtherPaymentMethodFromJSON(json: any): OtherPaymentMethod {
    return OtherPaymentMethodFromJSONTyped(json, false);
}

export function OtherPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherPaymentMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
    };
}

export function OtherPaymentMethodToJSON(json: any): OtherPaymentMethod {
    return OtherPaymentMethodToJSONTyped(json, false);
}

export function OtherPaymentMethodToJSONTyped(value?: OtherPaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
    };
}

